import { useNavigate } from 'react-router-dom';
import { firebaseAuthObj } from 'lib/firebase';

export const useLogout = () => {
    const navigate = useNavigate();
    return async () => {
        if (!!firebaseAuthObj) {
            await firebaseAuthObj.signOut();
        }
        navigate('/login');
    };
};
